export { default as InverseTextHero } from './InverseTextHero';
